module.exports = __webpack_public_path__ + "static/img/3-banner-default.b4a6b51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3-banner-default.jpg
// module id = iVUu
// module chunks = 0